export class ContainerView {
	//ParentElement of the container
	_parentElement = document.querySelector('.container');

	prepareContainer() {
		//1. clear container
		this._parentElement.innerHTML = '';

		//2. generate markup for the parent element of the view
		const markup = this._generateContainerMarkup();

		this._parentElement.insertAdjacentHTML('afterbegin', markup);

		this._scrollUp();
		// //3. set the parentElement object
		// this._parentElement = document.querySelector(this._parentElementName);
	}

	_scrollUp() {
		//the parentElement coordinates
		const lsCoords = this._parentElement.getBoundingClientRect();
		window.scrollTo({
			left: lsCoords.left + window.scrollX,
			top: lsCoords.top + window.scrollY,
			behavior: 'smooth',
		});
	}
}
